import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, convertToUTCISOString, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import CallDrawyer from "../../Contacts/ContactDetails/DrawyerPages/CallDrawyer";
import { ICall } from "../../DTO/Dto";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";


export const OverviewCalls: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getCallPermission;
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const params = useParams();
    const { id } = params
    const [open, setOpen] = React.useState(false);
    const [callLogListData, setCallLogListData] = useState<any>([])
    const [resetLoad, setResetLoad] = useState(false)
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [formComponent, setFormComponent] = useState<any>()
    const resetTrigger = useSelector((state: any) => state.components?.callLogGrid?.resetTrigger);
    const isMobile = IsSmallScreen();
    useEffect(() => {
        if (resetTrigger) {
            const getCalls = async () => {
                try {
                    setResetLoad(false)
                    const response: any = await callAPI('call-logs/lead', Method.GET, null, id);
                    if (response.data) {
                        setCallLogListData(response?.data || []);
                    }
                }


                catch (e) {

                }
            }
            if (id) {
                getCalls();
            }
        }
    }, [resetTrigger]);
    useEffect(() => {

        const getCalls = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI('call-logs/lead', Method.GET, null, id);
                if (response.data) {
                    setCallLogListData(response?.data || []);
                }
            }


            catch (e) {

            }
        }
        if (id) {
            getCalls();
        }
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'dateTime',
            isHide:isMobile
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,
            type: 'status',
            isHide:isMobile
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'date'
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,
            //  type: 'status'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {

            const form: any = <CallDrawyer
                id={id}
                control={control}
                register={register}
                callId={row.id}
                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

            />
            setFormComponent(form)
            setTimeout(() => {
                setOpen(true)
            }, 10);
        }
    }
    const handleCallData = async (data: any) => {
        try {
            dispatch(storeDataComponent('callSubmit', { loading: true }));
            const response: any = await saveData(data);
            if (response && response?.message) {
                dispatch(resetDataComponent('callLogGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('callLogGrid'));
                setResetLoad(true)
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(true)
        }
        finally {
            dispatch(updateDataComponent('callSubmit', { loading: false }));
        }

    }
    const saveData = async (data: ICall) => {
        const callStart: any = convertToUTCISOString(data?.callStart.toString());
        const request: ICall = {
            callType: data?.callType || "",
            callStart: callStart || "",
            callDuration: Number(data.callDuration) || 0,
            callPurpose: data?.callPurpose || "",
            leadId: id || "",
            callResult: data.callResult || "",
            description: data.description,
            subject: data?.subject || "",
            callStatus: data?.callStatus
        }
        if (data?.callId) {
            const response: any = await callAPI("call-logs", Method.PUT, request, data.callId);
            return response
        } else {
            const response: any = await callAPI("call-logs", Method.POST, request);
            return response
        }

    }

    const handleCallClick = () => {
        const form: any = <CallDrawyer
            id={id}
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setOpen(false) }}

        />
        setFormComponent(form)
        setTimeout(() => {
            setOpen(true)
        }, 10);
    }

    return (
        <>
            <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
                {view ? <Grid item xs={12}>
                    { <WSDataGrid
                        id="callLogGrid"
                        title="Calls"
                        data={callLogListData}
                        columns={columns}
                        addButton={add?{ label: "New", color: "secondary" }:undefined}
                        onAddButtonClick={handleCallClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                    />
                    } 
                    {/* {isMobile && callLogListData.length>0 &&
                        <WSMobileDataGridAdvanced title={'Calls'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleCallClick} columns={mobColumns} id="callLogGrid" data={callLogListData} />
                    } */}
                </Grid>
                    : <PermissionDenied />}
            </Grid>
            {formComponent && <SwipeableDrawerForm anchor="right" title={'Calls'} isMobile={isMobile}
                openForm={open}
                formComponent={<form onSubmit={handleSubmit(handleCallData)}>
                    {formComponent}
                </form>}
                onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

            />}

        </>
    );
});
